(function (w, $, _) {
    'use strict';

    var labels = w.customFieldsMetadata;
    var _plupload = null;

    function removeFiles(fileIds) {
        return $.ajax({
            url: w.R + 'Handlers/ArchiveData.ashx',
            type: 'POST',
            data: { action: 'delete', itemIds: JSON.stringify(fileIds) }
        });
    };

    function init() {
        $('.customfield-fileupload').each(function () {
            const $uploadedFileIdsHiddenInput = $(this);
            const $fileUploaderContainer = $uploadedFileIdsHiddenInput.parent();
            const customFieldData = $uploadedFileIdsHiddenInput.data('customfield') || { label: $fileUploaderContainer.find('.customFieldLabel').text()};
            const customFieldName = customFieldData.label;
            const uploaderParams = $uploadedFileIdsHiddenInput.data('uploaderparams') || {};
            const initialValues = $uploadedFileIdsHiddenInput.val();
            let uploadedFiles = initialValues ? _.map(initialValues.split(','), function (initVal) { return parseInt(initVal); }) : [];

            function $buildFileItem(fileInfo) {
                const $fileInfoLinkContainer = $('<li />', {
                    'id': 'uploadedfile_' + fileInfo.itemID,
                    'class': 'fileupload-file-uploaded'
                });

                let $fileInfo;
                if (fileInfo.fileSize > 0) {
                    $fileInfo = $('<a />', {
                        'href': w.R + 'ViewFile.aspx?ItemID=' + fileInfo.itemID,
                        'target': '_blank',
                        'class': 'file-name',
                        'text': fileInfo.fileName + ' (' + _plupload.formatSize(fileInfo.fileSize) + ')'
                    });
                } else {
                    $fileInfo = $('<span />', {
                        'text': fileInfo.fileName + ': ID=' + fileInfo.itemID
                    });

                    $fileInfoLinkContainer.addClass('filenotfound');
                }

                const $deleteButton = $('<a />', {
                    'class': 'glyphicon glyphicon-trash ml10 delete-file',
                    'href': '#',
                    'text': 'X',
                    'data': {
                        fileId: fileInfo.itemID
                    },
                    'click': function(evt) {
                        evt.preventDefault();

                        const $this = $(this);
                        const $fileItem = $this.closest('.fileupload-file-uploaded');
                        const fileId = $this.data('fileId');
                        const fileRemovedCallback = function() {
                            $fileItem.remove();
                            setUploadedFiles(_.without(uploadedFiles, fileId));
                        };

                        if ($fileItem.hasClass('filenotfound')) {
                            fileRemovedCallback();
                        } else {
                            if (fileId) {
                                $.when(removeFiles([fileId]))
                                    .done(fileRemovedCallback)
                                    .fail(function() {
                                        w.PubSub.publish('notification.error', labels.failedToRemoveFiles + ' ' + fileId);
                                    });
                            }
                        }
                    }
                });

                $fileInfoLinkContainer.append($fileInfo, $deleteButton);

                return $fileInfoLinkContainer;
            }

            function setUploadedFiles(newUploadedFiles) {
                uploadedFiles = newUploadedFiles;
                $uploadedFileIdsHiddenInput.val(uploadedFiles.join(','));
            }

            const $fileListContainer = $('<ul />', {
                'class': 'fileupload-filelist',
                'html': '<li class=\"loading\"><img src="' + w.R + 'SysImages/loading-bar.gif" alt="Loading..." /></li>'
            });
            $fileUploaderContainer.append($fileListContainer);

            if (uploadedFiles.length > 0) {
                $.ajax({
                        url: w.R + 'Handlers/Public/FilesData.ashx',
                        type: 'GET',
                        data: { action: 'getfilesinfo', ids: JSON.stringify(uploadedFiles) }
                    }).done(function(fileInfos) {
                        $fileListContainer.find('.loading').remove();
                        const notFoundFileIds = [];
                        _.each(fileInfos, function(fileInfo) {
                            const $fileItem = $buildFileItem(fileInfo);
                            $fileListContainer.append($fileItem);
                            if (fileInfo.fileSize <= 0) {
                                notFoundFileIds.push(fileInfo.itemID);
                            }
                        });

                        if (notFoundFileIds.length > 0) {
                            setUploadedFiles(_.difference(uploadedFiles, notFoundFileIds));
                        }
                    })
                    .fail(function() {
                        w.PubSub.publish('notification.error', customFieldName + ' ' + labels.failedToLoadFileDetails);
                    });
            } else {
                $fileListContainer.find('.loading').remove();
            }

            if (uploaderParams.folderId) {
                const $uploadButton = $('<div />', {
                    'class': 'glyphicon glyphicon-upload mr10 fileupload-select-files',
                    'style': 'cursor: pointer;',
                    'text': '...'
                });
                $fileUploaderContainer.append($uploadButton);

                const fileTypes = uploaderParams.fileTypes ? [{ title: 'Custom types', extensions: uploaderParams.fileTypes }] : undefined;
                var uploader = new _plupload.Uploader({
                    browse_button: $uploadButton.get(0),
                    drop_element: $fileUploaderContainer.get(0),
                    container: $fileUploaderContainer.get(0),

                    url: w.R + 'Startup/Archive/Plupload.ashx?publish=true&folderid=' + uploaderParams.folderId,

                    filters: {
                        max_file_size: '10mb',
                        mime_types: fileTypes
                    },
                    flash_swf_url: w.R + 'js/plupload-2.3.6/Moxie.swf',
                    silverlight_xap_url: w.R + 'js/plupload-2.3.6/Moxie.xap',

                    multi_selection: uploaderParams.multiupload,

                    init: {
                        FilesAdded: function (up, files) {
                            var startUpload = function() {
                                const $fileUploadProgressContainer = $('<ul class=\"fileupload-progress-container\"></ul>');
                                _.each(files, function (file) {
                                    $fileUploadProgressContainer.append('<li>' + file.name + ' (' + _plupload.formatSize(file.size) + ') <strong id="' + file.id + '-progress">0%</strong></li>');
                                });

                                $.blockUI({ message: $fileUploadProgressContainer });

                                // Upload immediately
                                uploader.start();
                            }

                            if (!uploaderParams.multiupload) {
                                $.when(removeFiles(uploadedFiles))
                                    .done(function() {
                                        $fileListContainer.empty();
                                        setUploadedFiles([]);
                                        startUpload();
                                    })
                                    .fail(function() {
                                        w.PubSub.publish('notification.error', labels.failedToRemoveFiles + ' ' + uploadedFiles.join(','));
                                    });
                            } else {
                                startUpload();
                            }
                        },

                        UploadProgress: function (up, file) {
                            document.getElementById(file.id + '-progress').innerHTML = file.percent + '%';
                        },

                        FileUploaded: function (up, file, result) {
                            const uploadedFileId = parseInt(result.response);
                            if (uploadedFileId) {
                                uploadedFiles.push(uploadedFileId);
                                $uploadedFileIdsHiddenInput.val(uploadedFiles.join(','));

                                const fileInfo = { itemID: uploadedFileId, fileName: file.name, fileSize: file.size };
                                $fileListContainer.append($buildFileItem(fileInfo));
                            } else {
                                w.PubSub.publish('notification.error', 'Failed to upload file ' + file.name);
                            }
                        },

                        UploadComplete: function (up) {
                            // Called when all files are either uploaded or failed
                            $.unblockUI();

                            up.refresh();
                            $fileUploaderContainer.find('.ErrMsg').hide();
                        },

                        Error: function (up, err) {
                            w.PubSub.publish('notification.error', err.message + ' ' + err.response);

                            up.refresh();
                        },
                    }
                });

                uploader.init();
            } else {
                const folderIsNotSetErrorMessage = labels.uploadFolderIsNotSet;
                $fileUploaderContainer.append($('<span />', {
                    'class': 'fileupload-error',
                    'text': folderIsNotSetErrorMessage
                }));

                w.PubSub.publish('notification.error', customFieldName + ' ' + folderIsNotSetErrorMessage);
            }
        });
    }

    w.require(['plupload'], function (plupload) {
        _plupload = plupload;

        w.customFieldsController = function() {
            return {
                init: init,
            };
        };

        $(function () {
            init();
        });
    });
})(window, jQuery, _);